window.Lang = {
	/*chat*/
	CHAT_CROSS_DES:"等级不足50级",
	CHAT_Gang_DES:"您暂时没有加入公会",

	/*召唤*/
	FREE_RECRUIT: "<color=#35ff14><outline=2, color=#000000>%s</outline></color><color=#ffffff><outline=2, color=#000000>后免费</outline></color>",
	SCORE_RECRUIT: "消耗%d点积分可进行积分召唤，必出5星传说英雄",

	DIAMOND_CONSUME: "是否使用<img src=%s visible=true scale=1 /><div fontColor=#289b14 fontsize= 26>%s</div><div fontColor=#764519>(拥有:</div><div fontColor=#289b14 fontsize= 26>%s</div><div fontColor=#764519>)\n</div>",
	BUY_DES: "<div fontColor=#764519>购买</div><div fontColor=#289b14 fontsize= 26>%s</div><div fontColor=#764519></div><div fontColor=#d95014 fontsize= 26>%s</div><div fontColor=#764519>(同时附赠</div><div fontColor=#289b14 fontsize= 26>%s</div><div fontColor=#764519>次招募)</div>",

	/*背包*/
	GET_WAYS: "获取途径",
	ITEM_HAVE: "拥有%s个",
	COMPASS: "通关",
	LOCK: "解锁",
	LEV_LOCK: "级解锁",

	/*公会*/
	GUILD: "公会",
	NOT_GUILD: "尚未加入公会",

	/*tips*/
	GOTO: "前往",
	NO_OPEN: "未开启",

	/*Hero*/
	COMMON_HERO: "不能同时上阵2个相同英雄",
	NOT_POS: "没有上阵位置",
	FULL_POS: "上阵人数已满",
	MINIMUM_NUM: "至少需要上阵一个英雄",
	NO_HERO: "没有英雄",
	LEVEL_UP: "升级",
	BREAK_UP: "进阶",

	/*祭祀*/
	OFFET_DES: "献祭英雄可获得材料，若英雄有进行升级、进阶、升星培养，也会100%返还所消耗的进阶石、金币和英雄经验。本次献祭所得如下：",

	LOADING_DESC_1: "副本推图关卡越高，获取角色经验、金币、英雄经验效率越高",
	LOADING_DESC_2: "英雄升星、进阶可大幅提高英雄属性成长，升级属性加成提高",
	LOADING_DESC_3: "加入公会，一起打Boss可以赚取大量公会贡献",
	LOADING_DESC_4: "战斗不停！即使离线也会不断获得经验、金币、英雄碎片等挂机奖励",
	LOADING_DESC_5: "快速作战可以立即获得大量角色经验和资源",	
	LOADING_DESC_6: "挑战竞技场拿竞技奖杯，珍贵英雄、先知水晶超值兑换",	
	LOADING_DESC_7: "游戏怎么玩？推图、爬塔、打Boss、养英雄玩竞技，感受成长的乐趣",
	LOADING_DESC_8: "不知道做什么？日常任务点一点",
	LOADING_DESC_9: "先知召唤大概率可获得高星英雄",
	LOADING_DESC_10: "试练塔可以获得大量英雄进阶材料，帮助英雄更快成长",
	LOADING_DESC_11: "神界冒险每2天重置1次，不要忘了噢",	
	LOADING_DESC_12: "精灵商店可获得各种折扣物品，召唤卷、先知水晶、进阶石应有尽有",	
	LOADING_DESC_13: "不知道如何提升？点一下剧情战斗界面的英雄变强按钮吧~",
}